import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class UserService {
  static loadUsers() {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadAllUsers() {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/all`;
    return axios.get(url).then((response) => response.data);
  }

  static findAllActive() {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}`;
    return axios.get(url).then((response) => response.data);
  }

  static getUser(id) {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static findByAuthToken(token) {
    const url = `${endpoints.BASE_URL}${endpoints.GET_USER_BY_TOKEN}`;
    const body = {
      token
    };

    return axios.post(url, body).then((response) => {
      if (response.data.check_gfs) localStorage.setItem("check_gfs", true);
      return response.data;
    });
  }

  static loginUser(user) {
    const url = `${endpoints.BASE_URL}${endpoints.LOGIN}`;

    const body = {
      user
    };

    return axios.post(url, body).then((response) => {
      if (response.data?.user) {
        localStorage.setItem("grav_token", response.data.tokens.access.token);
        localStorage.setItem(
          "gv_refresh_token",
          response.data.tokens.refresh.token
        );
        localStorage.setItem("username", response.data.user.email);
      }
      return response.data;
    });
  }

  static async authRefresh() {
    const url = `${endpoints.BASE_URL}${endpoints.REFRESH}`;
    const refreshToken = localStorage.getItem("gv_refresh_token");

    return axios.post(url, { refreshToken }).then((res) => {
      // Handle refresh token expiration error
      if (res.data.statusCode === 500) {
        return res.data;
      }
      localStorage.setItem("grav_token", res.data.tokens.access.token);
      localStorage.setItem("gv_refresh_token", res.data.tokens.refresh.token);
      return res.data;
    });
  }

  static async logoutUser() {
    const url = `${endpoints.BASE_URL}${endpoints.LOGOUT}`;
    const refreshToken = localStorage.getItem("gv_refresh_token");

    return axios.post(url, { refreshToken }).finally(() => {
      localStorage.removeItem("grav_token");
      localStorage.removeItem("username");
      localStorage.removeItem("gv_refresh_token");
    });
  }

  static forgotPassword(user) {
    const url = `${endpoints.BASE_URL}${endpoints.FORGOT}`;
    const body = {
      email: user.email
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static resetPassword(user) {
    const url = `${endpoints.BASE_URL}${endpoints.RESET}`;

    return axios.post(url, user).then((response) => response.data);
  }

  static createUser(user) {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}`;
    const body = {
      user
    };
    return axios.post(url, body).then((response) => response.data);
  }

  static updateUser(user) {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/${user.id}`;
    const body = {
      user
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteUser(id) {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/${id}`;

    return axios.delete(url).then((response) => response.data);
  }

  static uploadFile(id, file) {
    const formData = new FormData();
    formData.append("avatarUpload", file);

    const url = `${endpoints.BASE_URL}${endpoints.USERS}/${id}/upload`;

    return axios.post(url, formData).then((response) => response.data.Location);
  }

  static checkCallCount(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CHECK_CALLS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static getUsersByStatus(body) {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/by-status?${body}`;
    return axios.get(url).then((response) => response.data);
  }

  static loadProjectManagers() {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/project-managers`;
    return axios.get(url).then((response) => response.data);
  }

  static loadUserResourceSummary(userId) {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/${userId}/resource-summary`;
    return axios.get(url).then((response) => response.data);
  }

  static findByFilters(body) {
    const url = `${endpoints.BASE_URL}${endpoints.USERS}/list?${body}`;
    return axios.get(url).then((response) => response.data);
  }
}

export default UserService;
